import { z } from 'zod';

export const OrganizationUserInviteParamsSchema = z.object({
  organizationId: z.uuid(),
  inviteId: z.uuid(),
});

export type OrganizationUserInviteParams = z.infer<typeof OrganizationUserInviteParamsSchema>;

export const AcceptLocalOrganizationUserResponseSchema = z.object({
  inviteId: z.uuid(),
  userId: z.uuid(),
});

export type AcceptLocalOrganizationUserResponse = z.infer<
  typeof AcceptLocalOrganizationUserResponseSchema
>;
